export function checkIfStuck(elem, positionAttribute = "top", threshold = 0, innerWindow) {
  if (!elem) {
    return false;
  }
  const pos = elem.getBoundingClientRect()[positionAttribute];
  const stickyPoint = parseInt((innerWindow || window).getComputedStyle(elem)[positionAttribute], 10);
  if (positionAttribute === "top") {
    return pos <= stickyPoint + threshold && window.scrollY > 10;
  } else if (positionAttribute === "bottom") {
    return pos + stickyPoint >= window.innerHeight - threshold;
  }
  return false;
}